import React, { useState, useEffect } from 'react';
import {FormComponent} from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';

const CrmCustomColumnSizeComponent = ({
  document,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {
  return (
    <style>
      {".ft-dynamic-container-full-width {display:flex;flex-direction:column;flex:100%;margin-right:0!important}@media screen and (max-width:520.98px) {.divContainer {row-gap:0}.ft-dynamic-container {display:flex;flex-direction:column;flex:100% !important;}.ft-dynamic-container,.ft-dynamic-container-full-width {margin-right:0 !important}}@media screen and (min-width:521px) and (max-width:767.98px) {.ft-dynamic-container {display:flex;flex-direction:column;flex:0 1 calc(50% - 10px) !important;}}@media screen and (min-width:768px) and (max-width:991.98px) {.ft-dynamic-container {display:flex;flex-direction:column;flex:0 1 calc(50% - 10px) !important;}}@media screen and (min-width:992px) and (max-width:1199.98px) {.ft-dynamic-container {display:flex;flex-direction:column;flex:0 1 calc(50% - 10px) !important;}}@media screen and (min-width:1200px) {.ft-dynamic-container {display:flex;flex-direction:column;flex:0 1 calc(50% - 10px) !important;}}.ft-dynamic-container{flex: 0 1 calc(50% - 10px);}"}
    </style>
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('crm-custom-column-size', CrmCustomColumnSizeComponent);

export default CrmCustomColumnSizeComponent;
